// extracted by mini-css-extract-plugin
export default {"button":"NewButtonsSelect_button__+OINI","active":"NewButtonsSelect_active__gr8pA"};